import classNames from "classnames";
import type { ChangeEvent, KeyboardEvent } from "react";
import { bgStyles, paddingStyles } from "../../styles";
import type { PropsWithClassName, PropsWithOptionalAutoFocus, PropsWithOptionalPlaceholder } from "../../types";
import formStyles from "../forms.module.css";

export interface Props extends PropsWithClassName, PropsWithOptionalPlaceholder, PropsWithOptionalAutoFocus {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
}
export function RawTextInput({ onChange, placeholder, value, className, autoFocus, onKeyDown }: Props) {
  return (
    <input
      dir="auto"
      autoComplete="off"
      onKeyDown={onKeyDown}
      className={classNames(bgStyles.neutral0, paddingStyles.p0875, formStyles.input, className)}
      type="text"
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      autoFocus={autoFocus}
    />
  );
}
